import { render, staticRenderFns } from "./ImportTopicModel.vue?vue&type=template&id=ad45b7f8&"
import script from "./ImportTopicModel.vue?vue&type=script&lang=js&"
export * from "./ImportTopicModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports